<template>
  <section class="moat">
    <div class="container">
      <h2 class="section-title">竞争护城河</h2>
      <p class="section-subtitle">为什么这个赛道很难被复制</p>
      
      <div class="moat-grid">
        <div class="moat-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>数据积累优势</h3>
          <p>数百万学生与企业的能力数据、任务数据、成果数据，构建AI能力评价模型的核心资产</p>
        </div>

        <div class="moat-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>双边网络效应</h3>
          <p>用户越多，平台对学生和企业的价值越大，形成指数级增长的网络效应锁定</p>
        </div>

        <div class="moat-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="13 2 13 9 20 9"/>
            </svg>
          </div>
          <h3>区块链可信性</h3>
          <p>不可篡改的能力验证记录，成为唯一可信的第三方数字证明，无法被替代</p>
        </div>

        <div class="moat-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="9" cy="7" r="4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 21v-2a4 4 0 00-3-3.87" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 3.13a4 4 0 010 7.75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>用户粘性</h3>
          <p>学生依赖平台构建职业履历，企业依赖平台找到合适人才，形成强粘性</p>
        </div>

        <div class="moat-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 110-7.07M12 12a2 2 0 110-4 2 2 0 010 4z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>技术与运营</h3>
          <p>完整的AI能力评价算法、任务质量控制、风控系统，高壁垒的技术积累</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompetitiveMoat'
}
</script>

<style scoped>
.moat {
  padding: 5rem 2rem;
  background: #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.moat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.moat-card {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 1px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
  text-align: center;
}

.moat-card:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.card-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  color: #00D9FF;
}

.card-icon svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 0 10px rgba(0, 217, 255, 0.3));
}

.moat-card h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 0.75rem;
}

.moat-card p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .moat {
    padding: 3rem 1.5rem;
  }
}
</style>
